import React, {useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';

import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import InformationBox from '../../components/InformationBox';

import DropdownSelect from '../DropdownSelect';
import SortableDropdownSelect from '../SortableDropdownSelect';
import { DataGutters, DataGrid } from '../MetricSheet';
import { getDefaultYear, metricYear2Grid, updateGrid, updateMetricData } from '../../utils/impactUtils';

const useStyles = makeStyles(() => ({
    metricDropdown: {
        width: '70%',
        margin: '1rem'
    },
    structureDropdown: {
        width: '30%',
        margin: '1rem',
        visibility: 'hidden'
    },
    guardrailDropdown: {
        width:'95%',
        margin: '1rem'
    },
    error: {
        color: 'red',
        fontSize: '20px',
        paddingTop: '1rem',
        marginLeft: '1rem'
    },
    
}));

export default function PerformanceImprovementCard({ impact, updateImpact, updateMetric, createMetricYear, refreshValues, disabled, targetDisabled }) {
    const classes = useStyles();
    const { id: valueId, guardrailMetric, metricData, guardrailMetricData, metricId, structureId, metricYears } = impact;

    const [ valueMetric, setValueMetric ] = useState(metricId);
    const [ valueStructure, setValueStructure ] = useState(structureId);
    const [ guardMetric, setGuardrailMetric ] = useState(guardrailMetric);

    const [ currentYear, setCurrentYear ] = useState(getDefaultYear(metricYears));
    const [ metricGridData, setMetricGridData ] = useState(metricYear2Grid(metricData[currentYear]));
    const [ guardrailGridData, setGuardrailGridData ] = useState(metricYear2Grid(guardrailMetricData[currentYear]));

    useEffect(() => {
        setValueMetric(impact.metricId);
        setValueStructure(impact.structureId);
        setGuardrailMetric(impact.guardrailMetric);
        setMetricGridData(metricYear2Grid(impact.metricData[currentYear]));
        setGuardrailGridData(metricYear2Grid(impact.guardrailMetricData[currentYear]));
    }, [impact.metricId, impact.structureId, impact.guardrailMetric, impact.metricData, impact.guardrailMetricData, currentYear]);

    const onYearChange = (year) => {
        refreshValues();
        setCurrentYear(year);
        setMetricGridData(metricYear2Grid(metricData[year]));
        setGuardrailGridData(metricYear2Grid(guardrailMetricData[year]));
    };

    const onMetricChange = (e) => {
        updateImpact(valueId, 'metricId', e.target.value, () => { setValueMetric(e.target.value); });
    };

    const onStructureChange = (e, c) => {
        updateImpact(valueId, 'structureId', e.target.value, () => { setValueStructure(e.target.value); });
    };

    const onGuardrailMetricChange = (e) => {
        setGuardrailMetric(e.target.value);
    };
    const onGuardrailMetricBlur = (e) => {
        updateImpact(valueId, 'guardrailMetric', e.target.value, () => {});
    };

    const onMetricDataChange = (changes) => {
        setMetricGridData(updateGrid(metricGridData, changes));
        updateMetric(metricData[currentYear].id, updateMetricData(changes));
    };

    const onGuardrailDataChange = (changes) => {
        setGuardrailGridData(updateGrid(guardrailGridData, changes));
        updateMetric(guardrailMetricData[currentYear].id, updateMetricData(changes));
    };
    let showErr = valueMetric ? 'None' : 'flex';

    return (
        <div style={{width: '100%'}}>
            <div className={classes.error} style={{display: showErr, width: '100%'}}>
                This Performance Metric will not show up in net current cash until a "Baseline unit of measure" is selected.
            </div>
            <div style={{display: 'flex', width: '100%'}}>
                <SortableDropdownSelect
                    controlClass={classes.metricDropdown}
                    variant='outlined'
                    size='small'
                    label='Baseline unit of measure'
                    labelId='metric-label'
                    onChange={onMetricChange}
                    value={valueMetric || ''}
                    dropdownName={'ValueMetric'}
                    disabled={disabled}
                    sort={true}
                />
                <DropdownSelect
                    controlClass={classes.structureDropdown}
                    variant='outlined'
                    size='small'
                    label='Metric Structure'
                    labelId='structure-label'
                    onChange={onStructureChange}
                    value={valueStructure || ''}
                    dropdownName={'ValueStructure'}
                    disabled={disabled}
                />
            </div>

            <DataGutters
                onNewYear={(year) => createMetricYear(valueId, year, () => onYearChange(year))}
                onYearChange={onYearChange}
                currentYear={currentYear}
                setOfYears={metricYears}
                disabled={disabled}
            >
                <Typography variant='h5'>
                    {currentYear}
                </Typography>
                <DataGrid
                    currentYear={currentYear}
                    data={metricGridData}
                    onChange={onMetricDataChange}
                    disabled={disabled}
                    formatNumbersAsCurrency={true}
                    sapNumberFound={false}
                    isPerformanceCash={true}
                    targetDisabled={targetDisabled}
                    targetRow={0}
                />

                {/* <Typography variant='h5'>
                    Guardrail KPI
                </Typography> */}
                <br/>
                <InformationBox text='Guardrail KPI' description={'Enter a non-cash metric (free text field) that has a direct impact on cash flow. The metric should be used to explain variances in financial value.'} variant={'h5'}/><br/>
                <Typography variant='body1' style={{width: '100%'}} >
                    What is the metric we can use to measure the change created by this initiative?
                </Typography>
                <TextField
                    variant='outlined'
                    size='small'
                    fullWidth
                    label='Baseline unit of measure'
                    className={classes.guardrailDropdown}
                    onChange={onGuardrailMetricChange}
                    onBlur={onGuardrailMetricBlur}
                    value={guardMetric || ''}
                    disabled={disabled}
                />
                <DataGrid
                    currentYear={currentYear}
                    data={guardrailGridData}
                    onChange={onGuardrailDataChange}
                    disabled={disabled}
                    formatNumbersAsCurrency={false}
                    sapNumberFound={false}
                    targetDisabled={targetDisabled}
                />
            </DataGutters>
        </div>
    )
}

PerformanceImprovementCard.defaultProps = {
    impact: {
        id: '',
        metricId: '',
        structureId: '',
        metricYears: []
    }
};
